import React, { useCallback, useEffect, useState } from "react";
import { ReactComponent as CloseIcon } from "../../assets/icons/close-icon.svg";
import "./cardPopup.css";
import PopupWrapper from "../popupWrapper/popupWrapper";

export default function CardPopup({
  onClose,
  cardDetails,
  setViewLimit,
  handleOpenCreditCardPopup,
  limitCount,
  resend,
  handleResend,
}) {
  const [isCreditCardPopupVisible, setCreditCardPopupVisible] = useState(false);
  const preventCopyCut = (e) => {
    e.preventDefault();
  };

  const DetailsField = ({ id, label, className = "", subtext, value }) => (
    <div className={`form-group ${className}`}>
      {label && (
        <div htmlFor={id} className="card-label">
          {label}
        </div>
      )}
      <div
        className="card-value"
        onCopy={preventCopyCut}
        onCut={preventCopyCut}
      >
        {" "}
        {value}
        {"\u00A0"}{" "}
        <span>{subtext && <small className="subtext">{subtext}</small>}</span>
      </div>
    </div>
  );

  return (
    <PopupWrapper onClose={onClose}>
      {isCreditCardPopupVisible && cardDetails?.creditCardData && (
        <div className="limit-count">
          <p>{limitCount} attempts remaining</p>
        </div>
      )}
      <div className="popup-form" onSubmit={(e) => e.preventDefault()}>
        {isCreditCardPopupVisible ? (
          <>
            <DetailsField
              id="card-number"
              label="Card number"
              value={cardDetails?.creditCardData?.card_number || "-"}
            />
            <DetailsField
              id="card-holder"
              label="Card holder"
              value={cardDetails?.creditCardData?.card_holder || "-"}
            />
            <div className="form-group-row">
              <DetailsField
                id="exp-month"
                label="Expiration date"
                value={cardDetails?.creditCardData?.expiry || "-"}
                className="small"
              />
              <DetailsField
                id="cvv"
                label="CVV/CVC"
                value={cardDetails?.creditCardData?.cvv || "-"}
                className="small cvv"
                // subtext={cardDetails?.creditCardData?.cvv && "(3 digits)"}
              />
            </div>
          </>
        ) : (
          <div className="view-attempts">
            <h1>
              {resend
                ? "Confirm Resend Request"
                : !cardDetails?.response?.data?.error?.message
                ? "View attempts limit"
                : "View Attempts Exhausted!"}
            </h1>

            {resend ? (
              <p className="limit-reached">
                Do you want to resend the request to update credit card details?
              </p>
            ) : cardDetails?.response?.data?.error?.message ||
              limitCount === 0 ? (
              <p className="limit-reached">
                {cardDetails?.response?.data?.error?.message}
                {/* ||
                  "You have exhausted your 3 view attempts"} */}
              </p>
            ) : (
              <p>{`You have only ${limitCount} 
              attempts to view the credit card`}</p>
            )}
            {(cardDetails?.response?.data?.error?.message ||
              limitCount === 0) &&
            !resend ? (
              ""
            ) : (
              <div className="view-attempts-btn">
                <button
                  className="button reject"
                  onClick={() => setViewLimit(false)}
                >
                  No, cancel
                </button>
                <button
                  className="button accept"
                  onClick={
                    resend
                      ? () => {
                          handleResend();
                          setViewLimit(false);
                        }
                      : () => {
                          handleOpenCreditCardPopup();
                          setCreditCardPopupVisible(true);
                        }
                  }
                >
                  {resend ? "Resend" : "View"}
                </button>
              </div>
            )}
          </div>
        )}
      </div>
      {/* {cardDetails?.response?.data?.error?.message && (
        <p className="error">{cardDetails?.response?.data?.error?.message}</p>
      )} */}
    </PopupWrapper>
  );
}
